import { render, staticRenderFns } from "./NewLoginOtp.vue?vue&type=template&id=0d17fe78&scoped=true"
import script from "./NewLoginOtp.vue?vue&type=script&lang=js"
export * from "./NewLoginOtp.vue?vue&type=script&lang=js"
import style0 from "./NewLoginOtp.vue?vue&type=style&index=0&id=0d17fe78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d17fe78",
  null
  
)

export default component.exports